import React, { useState } from "react";

const TeamCard = ({ name, designation, description, profileImage }) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <div
      role="listitem"
      className="xl:w-1/3 sm:w-3/4 md:w-2/5 relative mt-16 mb-32 sm:mb-24 xl:max-w-xs lg:w-2/5"
    >
      <div className="rounded overflow-hidden shadow-md border border-primary">
        <div className="absolute -mt-20 w-full flex justify-center">
          <div className="h-32 w-32">
            <img
              src={profileImage}
              alt="Display of Andres Berlin"
              className="rounded-full object-cover h-full w-full shadow-md border border-primary"
            />
          </div>
        </div>
        <div className="px-6 mt-16">
          <h1 className="text-3xl text-center mb-1 text-primary black-bruno">
            {name}
          </h1>
          <p className="text-gray-300 font-semibold text-xl text-center mt-3">
            {designation}
          </p>

          <p className="text-center text-white text-base pt-3 font-normal pb-5">
            {description.length > 230 ? (
              <div>
                {showAll ? (
                  <div>
                    {description}
                    <br />
                    <button
                      onClick={() => setShowAll(false)}
                      className="text-primary"
                    >
                      Read Less
                    </button>
                  </div>
                ) : (
                  <div>
                    {description.substring(0, 200).concat("...")}

                    <br />
                    <button
                      onClick={() => setShowAll(true)}
                      className="text-primary"
                    >
                      Read More
                    </button>
                  </div>
                )}
              </div>
            ) : (
              description
            )}
          </p>
          {/* <div className="w-full flex justify-center pb-5 text-primary">
            <a href="https://discord.com/" className="mx-5">
              <FaDiscord className="text-2xl" />
            </a>
            <a href="https://twitter.com/" className="mx-5">
              <FaTwitter className="text-2xl" />
            </a>
            <a href="https://www.instagram.com/" className="mx-5">
              <FaInstagram className="text-2xl" />
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TeamCard;

